import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo30Y31Ano2025DatosGenerales() {
  return <CategoryPage category="anexo30Y31Ano2025DatosGenerales" pageTitle="Datos Generales 2025" />;
}

export default Anexo30Y31Ano2025DatosGenerales;
